/**
 * Ryan O'Dowd
 * 2025-06-08
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale}) => {
  return {
    container: { // @TODO: combine with checkbox
      flexDirection: 'row',
      alignItems: 'center',
    },
    label: (color) => { // @TODO: combine with checkbox
      return {
        color,
        fontSize: globalScale * 14,
        marginLeft: globalScale * 4,
      };
    },
  };
};

export default getStyles;
